import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/rejected cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a small delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // You can add analytics initialization here if needed
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-content">
        <div className="cookie-icon">🍪</div>
        <div className="cookie-text">
          <p className="cookie-message">
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
            By clicking "Accept All", you consent to our use of cookies. 
            <Link to="/privacy-policy" className="cookie-link">Learn more</Link>
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={rejectCookies} className="cookie-btn cookie-btn-reject">
            Reject
          </button>
          <button onClick={acceptCookies} className="cookie-btn cookie-btn-accept">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

